/**
 * Lightweight signal (no dependencies) that triggers on-demand loading of the Toaster component.
 * The Toaster chunk is only fetched when the first toast() call happens.
 * Toast calls are queued until the Toaster is mounted, then replayed.
 */
let activated = false
const activationListeners = new Set<() => void>()

export function activateToaster() {
  if (activated) return
  activated = true
  for (const fn of activationListeners) fn()
  activationListeners.clear()
}

export function onToasterActivated(fn: () => void): () => void {
  if (activated) {
    fn()
    return () => {}
  }
  activationListeners.add(fn)
  return () => {
    activationListeners.delete(fn)
  }
}

// Queue for toast calls made before the Toaster component has mounted
let toasterMounted = false
const pendingToasts: Array<() => void> = []

export function enqueueToast(fn: () => void) {
  if (toasterMounted) {
    fn()
  } else {
    pendingToasts.push(fn)
  }
}

export function flushPendingToasts() {
  toasterMounted = true
  const pending = pendingToasts.splice(0)
  for (const fn of pending) fn()
}
